'use client';

import { useState, useEffect } from 'react';

import { useAuth } from '@/providers/auth.provider';
import { handleErrors } from '@/helpers/handle-errors.helper';

import {
  PopupWrapper,
  Header,
  Title,
  CloseButton,
  WebinarList,
  WebinarItem,
  WebinarTitle,
  WebinarTime,
  WebinarLink,
} from './upcoming-webinar-popup.elements';

import { IconBrandZoom } from '@tabler/icons-react';

const UpcomingWebinarPopup = () => {
  const [webinars, setWebinars] = useState([]);
  const [visible, setVisible] = useState(() => {
    try {
      return sessionStorage.getItem('upcomingWebinarDismissed') !== 'true';
    } catch {
      return true;
    }
  });

  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;

    const controller = new AbortController();

    fetch('/api/v1/getUpcomingWebinars', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        period: '1h',
        userId: user.id,
      }),
      signal: controller.signal,
    })
      .then((res) => res.json())
      .then((data) => {
        setWebinars(data.webinars);
      })
      .catch((error) => {
        if (error.name !== 'AbortError') {
          handleErrors(error, { component: 'upcoming-webinar-popup', action: 'fetch webinars' });
        }
      });
  }, [user]);

  const handleDismiss = () => {
    try {
      sessionStorage.setItem('upcomingWebinarDismissed', 'true');
    } catch {}
    setVisible(false);
  };

  if (!user || !visible || !webinars || webinars.length === 0) return null;

  return (
    <PopupWrapper>
      <Header>
        <Title>Nadolazeći webinar{webinars.length > 1 ? 'i' : ''}</Title>
        <CloseButton onClick={handleDismiss}>×</CloseButton>
      </Header>
      <WebinarList>
        {webinars.map((webinar, idx) => (
          <WebinarItem key={idx}>
            <WebinarTitle>{webinar.title}</WebinarTitle>
            <WebinarTime>
              {new Date(webinar.date).toLocaleString('hr-HR', {
                dateStyle: 'short',
                timeStyle: 'short',
              })}
            </WebinarTime>
            <WebinarLink
              href={webinar.meetingLink}
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleDismiss}
            >
              <IconBrandZoom size={16} />
              Priključi se na Zoom
            </WebinarLink>
          </WebinarItem>
        ))}
      </WebinarList>
    </PopupWrapper>
  );
};

export { UpcomingWebinarPopup };
